var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from 'react';
import { css } from '@patternfly/react-styles';
import PropTypes from 'prop-types';
import styles from '../../@patternfly/patternfly-next/components/Alert/alert.css.js';

import CheckCircleIcon from '@patternfly/react-icons/dist/esm/icons/check-circle-icon';
import ExclamationCircleIcon from '@patternfly/react-icons/dist/esm/icons/exclamation-circle-icon';
import ExclamationTriangleIcon from '@patternfly/react-icons/dist/esm/icons/exclamation-triangle-icon';
import InfoCircleIcon from '@patternfly/react-icons/dist/esm/icons/info-circle-icon';


export var variantIcons = {
  success: CheckCircleIcon,
  danger: ExclamationCircleIcon,
  warning: ExclamationTriangleIcon,
  info: InfoCircleIcon
};

var propTypes = {
  variant: PropTypes.oneOf(Object.keys(variantIcons)).isRequired,
  className: PropTypes.string
};

var defaultProps = {
  className: ''
};

var AlertIcon = function AlertIcon(_ref) {
  var variant = _ref.variant,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ['variant', 'className']);

  var Icon = variantIcons[variant];
  return React.createElement(
    'div',
    _extends({}, props, { className: css(styles.alertIcon, className) }),
    React.createElement(Icon, null)
  );
};

AlertIcon.propTypes = propTypes;
AlertIcon.defaultProps = defaultProps;

export default AlertIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@patternfly/react-core/dist/esm/components/Alert/AlertIcon.js
// module id = 207
// module chunks = 0